export class VendorNotesResultDto {
    note: string;
    allowEdit: boolean;
}
